export const isCreating = pathName =>
  pathName === '/create-organization';

export const isUpdating = pathName => pathName === '/settings';
